<div class="row mt-1 regulatory_row">
    <app-progress-bar [isLoading]="isLoadingFilters"></app-progress-bar>
    <div class="col-md-3 col-lg-3">
        <div class="form-group">
            <div class="left inline control-label mb-1">Date From</div>
            <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
                    class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
                    [(ngModel)]="impactAssessmentFilter.fromDate" readonly>
                <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
                </div>
            </div>
            <mat-datepicker #picker></mat-datepicker>
        </div>
    </div>
    <div class="col-md-3 col-lg-3">
        <div class="form-group">
            <div class="left inline control-label d-none d-sm-block mb-1">Date Until</div>
            <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
                    class="form-control form-control-sm border-bottom" id="toDate" placeholder="To"
                    [(ngModel)]="impactAssessmentFilter.toDate" readonly>
                <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
                </div>
            </div>
            <mat-datepicker #toPicker></mat-datepicker>
        </div>
    </div>
    <div class="col-md-3 col-lg-3">
        <div class="form-group">
            <div class="left inline control-label mb-1">Division</div>
            <mat-chip-grid #jurisList>
                <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.jurisdiction" [selectable]="selectable"
                    [removable]="removable" (removed)="removeJurisdiction(objItem)">
                    {{objItem}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #jInput
                    [formControl]="searchJCntrl" [matAutocomplete]="jAutocomplete" [matChipInputFor]="jurisList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addJurisdiction($event)">
            </mat-chip-grid>
            <mat-autocomplete #jAutocomplete="matAutocomplete" (optionSelected)="selectedJurisdictionEvent($event)">
                <mat-option *ngFor="let obj of searchedJ" [value]="obj.value">
                    {{obj.name}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div class="col-md-3 col-lg-3">
        <div class="form-group">
            <div class="left inline control-label mb-1">Key Words</div>
            <mat-chip-grid #keywordsList>
                <mat-chip-row *ngFor="let sQuery of impactAssessmentFilter.searchQuery" [selectable]="selectable"
                    [removable]="removable" (removed)="remove(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #keywordInput
                    [formControl]="keyCtrl" [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
            <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
                <mat-option *ngFor="let fK of filteredKeywords" [value]="fK">
                    {{fK}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
</div>
<div class="row mt-1 regulatory_row">
    <div class="col-md-4 col-lg-4">
        <div class="form-group">
            <div class="left inline control-label mb-1">Team</div>
            <mat-chip-grid #teamList>
                <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.team" [selectable]="selectable"
                    [removable]="removable" (removed)="removeTeam(objItem)">
                    {{objItem}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #teamInput
                    [formControl]="searchTeamCntrl" [matAutocomplete]="teamAutocomplete" [matChipInputFor]="teamList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addTeam($event)">
            </mat-chip-grid>
            <mat-autocomplete #teamAutocomplete="matAutocomplete" (optionSelected)="selectedTeamEvent($event)">
                <mat-option *ngFor="let obj of searchedTeam" [value]="obj.value">
                    {{obj.name}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div class="col-md-4 col-lg-4">
        <div class="form-group">
            <div class="left inline control-label mb-1">Named Personnel</div>
            <mat-chip-grid #namedPersonnelList>
                <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.namedPersonnel" [selectable]="selectable"
                    [removable]="removable" (removed)="removeNP(objItem)">
                    {{objItem}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #nPInput
                    [formControl]="searchNPCntrl" [matAutocomplete]="nPAutocomplete" [matChipInputFor]="namedPersonnelList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addNP($event)">
            </mat-chip-grid>
            <mat-autocomplete #nPAutocomplete="matAutocomplete" (optionSelected)="selectedNPEvent($event)">
                <mat-option *ngFor="let obj of searchedNP" [value]="obj.value">
                    {{obj.name}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div class="col-md-4 col-lg-4">
        <div class="form-group">
            <div class="left inline control-label mb-1">Rule Type</div>
            <mat-chip-grid #rtlList>
                <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.ruleType" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRT(objItem)">
                    {{objItem}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #rTypeInput
                    [formControl]="searchRuleTypeCntrl" [matAutocomplete]="rTypeAutocomplete" [matChipInputFor]="rtlList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addRT($event)">
            </mat-chip-grid>
            <mat-autocomplete #rTypeAutocomplete="matAutocomplete" (optionSelected)="selectedRTEvent($event)">
                <mat-option *ngFor="let obj of searchedRuleType" [value]="obj.value">
                    {{obj.name}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div class="col-md-4 col-lg-4">
        <div class="form-group">
            <div class="left inline control-label mb-1">Rag Rating</div>
            <mat-chip-grid #rRlList>
                <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.ragRating" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRR(objItem)">
                    {{objItem}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #rRInput
                    [formControl]="searchRRCntrl" [matAutocomplete]="rRAutocomplete" [matChipInputFor]="rRlList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addRR($event)">
            </mat-chip-grid>
            <mat-autocomplete #rRAutocomplete="matAutocomplete" (optionSelected)="selectedRREvent($event)">
                <mat-option *ngFor="let obj of searchedRR" [value]="obj.value">
                    {{obj.name}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div class="col-md-4 col-lg-4">
        <div class="form-group">
            <div class="left inline control-label mb-1">Response Approach</div>
            <mat-chip-grid #rAlList>
                <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.responseApproach" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRA(objItem)">
                    {{objItem}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #rAInput
                    [formControl]="searchRACntrl" [matAutocomplete]="rAAutocomplete" [matChipInputFor]="rAlList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addRA($event)">
            </mat-chip-grid>
            <mat-autocomplete #rAAutocomplete="matAutocomplete" (optionSelected)="selectedRAEvent($event)">
                <mat-option *ngFor="let obj of searchedRA" [value]="obj.value">
                    {{obj.name}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div class="col-md-4 col-lg-4">
        <div class="form-group">
            <div class="left inline control-label mb-1">Current Status</div>
            <mat-chip-grid #cSList>
                <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.currentStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeCS(objItem)">
                    {{objItem}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #cSInput
                    [formControl]="searchCSCntrl" [matAutocomplete]="cSAutocomplete" [matChipInputFor]="cSList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addCS($event)">
            </mat-chip-grid>
            <mat-autocomplete #cSAutocomplete="matAutocomplete" (optionSelected)="selectedCSEvent($event)">
                <mat-option *ngFor="let obj of searchedCS" [value]="obj.value">
                    {{obj.name}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div class="col-md-4 col-lg-4">
        <div class="form-group">
            <div class="left inline control-label mb-1">Engagement Plan</div>
            <mat-chip-grid #ePList>
                <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.engagementplan" [selectable]="selectable"
                    [removable]="removable" (removed)="removeEP(objItem)">
                    {{objItem}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #ePInput
                    [formControl]="searchEPCntrl" [matAutocomplete]="ePAutocomplete" [matChipInputFor]="ePList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addEP($event)">
            </mat-chip-grid>
            <mat-autocomplete #ePAutocomplete="matAutocomplete" (optionSelected)="selectedEPEvent($event)">
                <mat-option *ngFor="let obj of searchedEP" [value]="obj.value">
                    {{obj.name}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div class="col-md-4 col-lg-4">
        <div class="form-group">
            <div class="left inline control-label mb-1">Policy Response Achieved</div>
            <mat-chip-grid #prAList>
                <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.policyResponseAchieved" [selectable]="selectable"
                    [removable]="removable" (removed)="removePRA(objItem)">
                    {{objItem}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom" #prAInput
                    [formControl]="searchPRACntrl" [matAutocomplete]="prAAutocomplete" [matChipInputFor]="prAList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addPRA($event)">
            </mat-chip-grid>
            <mat-autocomplete #prAAutocomplete="matAutocomplete" (optionSelected)="selectedPRAEvent($event)">
                <mat-option *ngFor="let obj of searchedPRA" [value]="obj.value">
                    {{obj.name}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div class="col-md-4 col-lg-3">
        <div class="form-group">
            <div class="left inline control-label mb-1">Id </div>
            <mat-chip-grid #idList>
                <mat-chip-row *ngFor="let type of impactAssessmentFilter.updatesDBId" [selectable]="selectable"
                    [removable]="removable" (removed)="removeId(type)">
                    {{type}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm border-bottom" type="number" id="type" autocomplete="off"
                    [matChipInputFor]="idList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addId($event)">
            </mat-chip-grid>
        </div>
    </div>
    <div class="col-md-3 col-lg-2">
        <div class="form-group">
            <span class="ml-2 btn btn-sm pl-1" (click)="initFilters()">Reset</span>
            <button type="button" class="btn btn-sm bg-purple text-white ml-2 btn-blue text-white" id="btn-search"
                (click)="triggerAction()">Submit</button>
        </div>
    </div>
</div>
